var render, staticRenderFns
import script from "./formItemDetail.vue?vue&type=script&lang=js"
export * from "./formItemDetail.vue?vue&type=script&lang=js"
import style0 from "./formItemDetail.vue?vue&type=style&index=0&id=3c48cd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../base/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48cd82",
  null
  
)

export default component.exports